"use client";

import React from "react";
import ContactInformationForm from "./ContactInformationForm";
import BusinessBuyingProfile from "./BusinessBuyingProfile";
import BuyingProfilePersonal from "./BuyingProfilePersonal";
import { useFormContext, FormProvider } from "./context/FormContext";
import { ProgressIndicator } from "./ProgressIndicator";
import FormProgressIndicator from "./FormProgressIndicator";
import FormSubmitSuccess from "./FormSubmitSuccess";
import Animate from "@/components/Animate";

const ContactForm = () => {
  return (
    <FormProvider>
      <ContactFormContent />
    </FormProvider>
  );
};

const ContactFormContent = () => {
  const { step, isSubmitting } = useFormContext();

  return (
    <div className="w-full lg:max-w-[36.625rem]">
      <Animate animation="fadeIn" delay={0.4}>
        <div className="w-full rounded-[0.375rem] border border-system-napoleon bg-system-obsidian px-8 py-8 sm:px-12 sm:py-12">
          {isSubmitting ? (
            <ProgressIndicator className="h-[400px]" />
          ) : step === "success" ? (
            <FormSubmitSuccess />
          ) : (
            <>
              <FormProgressIndicator />
              {step === "contact" && <ContactInformationForm />}
              {step === "business" && <BusinessBuyingProfile />}
              {step === "personal" && <BuyingProfilePersonal />}
            </>
          )}
        </div>
      </Animate>
    </div>
  );
};

export default ContactForm;
